import { get, post, del } from '../axios/index.js';
// 用户
export const user_login = data => post('api/user/login', data);
export const user_register = data => post('api/user/register', data);

// 产品信息
export const item_list_by_tree = treeId => get('api/item/queryByTreeId/' + treeId);
export const item_add = data => post('api/item/add', data);
export const item_update = data => post('api/item/update', data);
export const item_del = id => del('api/item/' + id);
export const item_page = data => post('api/item/page', data);
export const item_detail = data => post('api/item/getItemDetails', data);
export const add_cart = data => post('api/web/addCart', data);
export const update_cart = data => post('api/web/updateCart', data);
export const query_cart = data => post('api/web/queryCartByItemId', data);
export const cart_list = data => post('api/web/cartList', data);
export const submit_order = data => post('api/web/submitOrder', data);
export const order_list = data => post('api/web/orderList', data);
export const order_cancel = data => post('api/web/cancelOrder', data);
export const order_detail = data => post('api/web/orderDetail', data);
export const cart_del = data => post('api/web/deleteCart', data);
export const itemName_list = data => post('api/item/getItemNames', data);
export const video_list = data => post('api/web/videoList', data);
export const itemName_update = data => post('api/item/updateItemName', data);
export const itemName_add = data => post('api/item/addItemName', data);
export const itemName_delete = id => del('api/item/delItemName/' + id);
export const itemName_update_sort = data => post('api/item/updateItemNameSort', data);
export const itemName_editFlag = data => post('api/item/updateItemNameFlag', data);

// 产品目录
export const tree_page = data => post('api/tree/page', data);
export const tree_query_list = data => post('api/tree/queryList', data);
export const tree_car_list = () => get('api/tree/queryCarList');
export const tree_level_all = data => post('api/tree/allLevelList', data);
export const tree_level_list_by_pid = id => get('api/tree/levelListByPid/' + id);
export const tree_by_id = id => get('api/tree/getById/' + id);
export const tree_add = data => post('api/tree/add', data);
export const tree_update = data => post('api/tree/update', data);
export const tree_update_show = data => post('api/tree/updateShow', data);
export const tree_del = id => del('api/tree/' + id);
export const tree_navs_by_id = data => post('api/tree/queryNavs', data);

export const item_page2 = data => post('api/item/page2', data);

// 视频管理
export const video_page = data => post('api/video/page', data);
export const video_add = data => post('api/video/add', data);
export const video_update = data => post('api/video/update', data);
export const video_update_sort = data => post('api/video/updateSort', data);
export const video_del = id => del('api/video/del/' + id);

// 用户
export const user_page = data => post('api/user/page', data);
export const user_del = id => del('api/user/' + id);
export const user_add = data => post('api/user/add', data);
export const user_update = data => post('api/user/update', data);
export const user_change_pwd = data => post('api/user/changePassword', data);
export const user_refresh_token = data => post('api/user/refreshToken', data);

// 订单
export const order_page = data => post('api/order/page', data);
export const order_click_and_get = id => get('api/order/clickAndGetOrder/' + id);
export const order_set_price = data => post('api/order/updatePriceUrl', data);
export const order_export = data => post('api/order/export', data);
export const order_export_single = id => get('api/order/exportById/' + id);
export const order_del = id => del('api/order/deleteOrder/' + id);

// 浏览
export const leave_page = data => post('api/leaveword/page', data);
export const leave_add = data => post('api/leaveword/add', data);
export const leave_del = id => del('api/leaveword/delete/' + id);

// 用户日志
export const userLog_page = data => post('api/userRecord/page', data);
export const userLog_list_by_user = data => post('api/userRecord/list_by_user', data);
export const userLog_del = id => del('api/userRecord/' + id);

// 系统配置
export const config_by_id = id => get('api/config/queryById/' + id);
export const config_update = data => post('api/config/update', data);

// web端
export const web_item_by_id = data => post('api/web/queryItemById', data);
export const web_navs_by_id = data => post('api/web/queryNavs', data);
export const web_search_items = data => post('api/web/searchItems', data);
export const web_tree_by_id = data => post('api/web/getTreeById/', data);
export const web_config_by_id = data => post('api/web/getConfigById', data);
export const web_current_user = data => post('api/web/getCurrentUser', data);






// WEBPACK FOOTER //
// ./src/api/api.js